import { Chip, Text, useTheme } from '@shared/components';

export type QuestionTypeChipProps =
  | { type: 'single' | 's-is' }
  | { type: 'item-set'; questionSize?: number | null };

export default function QuestionTypeChip(props: Readonly<QuestionTypeChipProps>) {
  const { type } = props;
  const theme = useTheme();

  const label = {
    single: 'Single',
    's-is': 'S/IS',
    'item-set':
      type === 'item-set' && props.questionSize ? `Item Set: ${props.questionSize}Q` : 'Item Set',
  };

  const backgroundColor = {
    single: theme.palette.primary.light,
    's-is': theme.palette.success.light,
    'item-set': theme.palette.info.light,
  };

  return (
    <Chip
      label={<Text variant='captionSemibold'>{label[type]}</Text>}
      size='small'
      sx={{
        backgroundColor: backgroundColor[type],
        minWidth: '62px',
      }}
    />
  );
}
